// extracted by mini-css-extract-plugin
export default {"arrows":"pagination_arrows__KMr-N","arrowContainer":"pagination_arrowContainer__unbp4","pagesText":"pagination_pagesText__mKiSm","arrowIcon":"pagination_arrowIcon__6EBza"};